module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "subtest-form"
    }
  }, [_c('v-card', {
    staticClass: "my-3",
    attrs: {
      "flat": ""
    }
  }, [_c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    Durasi (Menit)\n                ")]), _vm._v(" "), _c('v-list-item-subtitle', [_c('v-text-field', {
    attrs: {
      "id": "tryout-subtest-form-duration",
      "type": "number",
      "placeholder": "(menit)",
      "suffix": "menit",
      "step": "0.5",
      "outlined": ""
    },
    model: {
      value: (_vm.subtest.duration),
      callback: function($$v) {
        _vm.$set(_vm.subtest, "duration", $$v)
      },
      expression: "subtest.duration"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    KKM\n                ")]), _vm._v(" "), _c('v-list-item-subtitle', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "placeholder": "Isi KKM",
      "outlined": ""
    },
    model: {
      value: (_vm.subtest.kkm),
      callback: function($$v) {
        _vm.$set(_vm.subtest, "kkm", $$v)
      },
      expression: "subtest.kkm"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    Mata Pelajaran *\n                ")]), _vm._v(" "), _c('v-list-item-subtitle', [(_vm.$store.state.tryout.status) ? _c('app-choosemapel', {
    attrs: {
      "id": "tryout-subtest-form-mapel"
    },
    on: {
      "selected": function($event) {
        return _vm.mapelSelected($event)
      }
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-card', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', [_c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                Perakitan Test *\n                            ")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("\n                                Rakit test dengan mencari bab atau soal\n                                melalui tombol dibawah")])], 1)], 1), _vm._v(" "), _c('app-assemblesubtest', {
    key: _vm.keyAssembler,
    attrs: {
      "id": "tryout-subtest-form-perakitan",
      "pdisabled": _vm.subject,
      "subject": _vm.subject
    },
    on: {
      "updated": function($event) {
        return _vm.detailsUpdated($event)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "id": "tryout-subtest-back-btn",
      "depressed": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('back')
      }
    }
  }, [_vm._v("\n                Kembali\n            ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blew",
      "id": "tryout-subtest-save-btn",
      "depressed": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("\n                Simpan\n            ")])], 1)], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d452617","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/tryout/components/SubtestForm.vue
// module id = 2085
// module chunks = 1